var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tree',{attrs:{"data":_vm.data,"props":_vm.defaultProps,"highlight-current":"","config":_vm.config,"default-checked-keys":[_vm.checkedID],"node-key":_vm.treeNodeKey,"auto-expand-parent":false,"default-expand-all":true},on:{"node-click":_vm.handleNodeClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }